import React from "react";

const ArrowBottomIcon = (props: any) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.26095 7.12379C3.34013 7.04434 3.43421 6.9813 3.53781 6.93828C3.6414 6.89527 3.75247 6.87312 3.86464 6.87312C3.97682 6.87312 4.08788 6.89527 4.19148 6.93828C4.29507 6.9813 4.38916 7.04434 4.46834 7.12379L9.54575 12.2012L14.6246 7.12379C14.7847 6.96369 15.0019 6.87374 15.2283 6.87374C15.4547 6.87374 15.6719 6.96369 15.832 7.1238C15.9921 7.2839 16.082 7.50106 16.082 7.72749C16.082 7.95392 15.9921 8.17107 15.832 8.33118L10.1502 14.013C10.071 14.0925 9.97689 14.1555 9.8733 14.1985C9.7697 14.2415 9.65863 14.2637 9.54646 14.2637C9.43429 14.2637 9.32322 14.2415 9.21963 14.1985C9.11603 14.1555 9.02195 14.0925 8.94277 14.013L3.26095 8.33118C3.1815 8.252 3.11845 8.15792 3.07544 8.05432C3.03242 7.95073 3.01028 7.83966 3.01028 7.72749C3.01028 7.61532 3.03242 7.50425 3.07544 7.40065C3.11845 7.29706 3.1815 7.20297 3.26095 7.12379Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowBottomIcon;
